interface MenuItem {
	key: string;
	label: string;
	icon: React.ReactNode;
	route: string;
	children?: MenuItem[];
}

export const openItemOnSideBarClick = (
	item: MenuItem,
	hasChildren: boolean,
	toggleMenu: (key: string) => void,
	navigate: (route: string) => void,
) => {
	if (hasChildren) {
		toggleMenu(item.key);
	} else {
		navigate(item.route);
	}
};
